/**
 * ReviewsInfoSection - Information section showing how to share reviews and contact details
 * Two-column layout on desktop, stacked on mobile
 */

import type { FC } from "react";
import { usePrismicLabels } from "~/hooks/usePrismicLabel";

export const ReviewsInfoSection: FC = () => {
  const { $pt } = usePrismicLabels();

  // Get translations from Prismic labels
  const shareExperienceTitle = $pt("reviews_share_experience_title");
  const shareExperienceText = $pt("reviews_share_experience_text");

    const trustpilotTitle = $pt("reviews_etrusted_title");
  const trustpilotText = $pt("reviews_etrusted_text");

  const contactTitle = $pt("reviews_contact_title");
  const contactText = $pt("reviews_contact_text");

  return (
    <section className="subpage mb-10">
      <div className="reviews_info_section container">
        <div className="row flex-md-nowrap">
          {/* Left column - Share experience and Trustpilot text */}
          <div className="col-12 col-lg-6 mb-4 mb-lg-0 pl-0">
            <div
            className="reviews_info_section_text"
            >
              <h3 className="heading sans-serif strong mb-3 reviews_info_section_text_title">{shareExperienceTitle}</h3>
              <p className="reviews_info_section_text_paragraph mb-0">{shareExperienceText}</p>
            </div>  
            <div
            className="mt-4 reviews_info_section_text"
            >
              <h3 className="heading sans-serif strong mb-3 reviews_info_section_text_title">{trustpilotTitle}</h3>
              <p className="mb-0 reviews_info_section_text_paragraph">{trustpilotText}</p>
            </div>
          </div>

          {/* Right column - Contact info box */}
          <div className="col-12 col-lg-6 p-0 p-md-4 ml-md-2 h-100 reviews_info_section_contact">
            <div className="p-4 bg-gray-lighter-2">
              <h3 className="heading sans-serif strong mb-3 reviews_info_section_contact_title">{contactTitle}</h3>
              <p className="mb-0 reviews_info_section_contact_text_paragraph">{contactText}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ReviewsInfoSection;
